import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { showMutationError } from "@/lib/mutation-error";
import { partnerApiService } from "@/services/partner-api.service";
import type { AddTeamUserInput } from "@/types/partner.types";

export const useAddClientUser = (teamId: string) => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: (input: AddTeamUserInput) =>
			partnerApiService.addTeamUser(teamId, input),
		onSuccess: () => {
			toast.success("User added");
			queryClient.invalidateQueries({
				queryKey: ["partner", "clients", teamId, "users"],
			});
			queryClient.invalidateQueries({
				queryKey: ["partner", "clients", teamId],
			});
		},
		onError: (err) => {
			showMutationError(err, "Failed to add user");
		},
	});
};
